import { TimelineItem } from '../types';
import { timeline } from '../data/portfolioData';

// import datoCMSClient from './datoCMSClient';

export async function getTimeline(): Promise<TimelineItem[]> {
  return timeline;
}
